import { apiPost } from "./apiClient";

// Triggers a manual Dropbox sync on the dropbox-connector service (admin
// only). Resolves to the connector's response: { message, status } where
// status is "in_progress" or "already_in_progress".
export async function runDropboxSync() {
  return apiPost({
    endpoint: "/admin/run-dropbox-sync",
    data: {},
    withAuth: true,
  });
}
